// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22flR","newExpiryDate":"styles_newExpiryDate__2-XMY","footer":"styles_footer__Vq1oE"};